<!--
배송등록(수동) 에서 사용되는 상품(1개) 컴포넌트

-->
<template>
    <div class="">
        <!-- 리스트 -->
        <table class="uk-table uk-table-middle app-table-border-style">
            <colgroup>
                <col />
                <col style="width: 100px"/>
                <col />
                <col />
                <col />
                <col />
                <col style="width: 100px;"/>
            </colgroup>

            <thead>
            <tr>
                <th class="uk-text-center">회원사</th>
                <th class="uk-text-center">상품번호</th>
                <th class="uk-text-center">이미지</th>

                <th class="uk-text-center">뉴스킨 상품코드</th>

                <th>상품명(영문)</th>
                <th>상품명</th>
                <th class="uk-text-center">입고수량</th>
            </tr>
            </thead>

            <tbody>
            <tr
                    v-for="(prod, index) in prods"
                    :class="hasAmount(prod.amount) ? 'has-amount' : ''"
            >
                <td class="uk-text-center">{{ prod.user_nick }}</td>
                <td class="uk-text-center">
                    {{ prod.id }}
                    <a
                            class="uk-link"
                            onclick="$.app.on_event.move(arguments);"
                            :data-url="'/prods/'+prod.id"
                            data-target="_blank"
                            uk-tooltip="상품상세"
                    ><span uk-icon="link"></span></a>

                </td>
                <td class="uk-text-center">
                    <img :src="prod.img_url" width="100"/>
                </td>

                <td class="uk-text-center">{{ prod.vender_code }}</td>

                <td class="uk-text-large uk-text-primary">{{ prod.name_eng }}</td>
                <td>{{ prod.name }}</td>
                <td class="uk-text-center">
                    <!-- 상품ID -->
                    <input type="hidden" name="ids[]" :value="prod.id" />

                    <!-- 수량 -->
                    <app-input-text
                            class="input text-center"
                            input-size="large"

                            :name="'amount_'+prod.id"
                            v-model="prod.amount"

                            :validate-rules="{numeric: true}"
                    > </app-input-text>
                </td>
            </tr>
            </tbody>
        </table>


        <!-- 집계정보 -->
        <p class="uk-text-right">
            TOTAL COUNT : <span class="uk-text-primary uk-text-large">{{ totalAmount }}</span>
            <br />
            (of  <span class="uk-text-primary">{{ productCount }}</span> products)
        </p>

    </div>
</template>

<script>
    export default {
        props: {
            // 상품정보 배열
            prods: Array,
        },
        data: function () {
            return {
            };
        },
        computed: {
            // 총 수량
            totalAmount: function () {
                let total = 0;
                _.each(this.prods, function (prod) {
                    let amount = parseInt(prod.amount);
                    if (_.isNaN(amount)) {
                        amount = 0;
                    }
                    total += amount;
                });
                return total;
            },
            // 품목수
            productCount: function () {
                let count = 0;
                //console.log(this.hasAmount(0));
                let vm = this;
                _.each(this.prods, function (prod) {
                    if (vm.hasAmount(prod.amount)) {
                        count++;
                    }
                });

                return count;
            }
        },
        watch: {
        },
        methods: {
            /**
             * 수량이 존재하는지 여부 (1이상인지)
             */
            hasAmount: function (amount) {
                amount = parseInt(amount);
                return _.isNaN(amount) === false
                    && amount > 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    table th{
        background-color: #fafafa;
        color: #000;
    }
    .has-amount {
        background-color: #FFFD7C;
        color: #000;
    }
</style>